import { FiltersProvider } from 'hooks/filters';
import { FormsProvider } from 'hooks/forms';
import { CustomReportsProvider as Provider } from 'hooks/customReports';
import { ManagerQueryProvider } from 'services/manager';

const CustomReportsProvider = ({ children }) => (
	<ManagerQueryProvider>
		<FormsProvider>
			<FiltersProvider>
				<Provider>{children}</Provider>
			</FiltersProvider>
		</FormsProvider>
	</ManagerQueryProvider>
);

export default CustomReportsProvider;
